<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15.7,7.3C15.7,7.3,11.7,3.3,11.7,3.3C11.5,3.1,11.3,3,11,3C10.4,3,10,3.5,10,4C10,4.3,10.1,4.5,10.3,4.7C10.3,4.7,12.6,7,12.6,7C12.6,7,3.4,7,3.4,7C3.4,7,5.7,4.7,5.7,4.7C5.9,4.5,6,4.3,6,4C6,3.5,5.6,3,5,3C4.7,3,4.5,3.1,4.3,3.3C4.3,3.3,0.3,7.3,0.3,7.3C0.1,7.5,5.55112e-17,7.7,5.55112e-17,8C5.55112e-17,8.3,0.1,8.5,0.3,8.7C0.3,8.7,4.3,12.7,4.3,12.7C4.5,12.9,4.7,13,5,13C5.6,13,6,12.6,6,12C6,11.7,5.9,11.5,5.7,11.3C5.7,11.3,3.4,9,3.4,9C3.4,9,12.6,9,12.6,9C12.6,9,10.3,11.3,10.3,11.3C10.1,11.5,10,11.7,10,12C10,12.6,10.4,13,11,13C11.3,13,11.5,12.9,11.7,12.7C11.7,12.7,15.7,8.7,15.7,8.7C15.9,8.5,16,8.3,16,8C16,7.7,15.9,7.5,15.7,7.3C15.7,7.3,15.7,7.3,15.7,7.3C15.7,7.3,15.7,7.3,15.7,7.3Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ArrowsHorizontal',
} as DefineComponent
</script>
